export default __webpack_public_path__ + "static/Data-analytics-436be23a718852068be648b59eeaae41.webp";